import clsx from "clsx";
import { memo } from "react";

export interface PlaybackSpeedSelectorProps {
  currentSpeed: number;
  showSpeedMenu: boolean;
  onSpeedChange: (speed: number) => void;
  onToggleMenu: () => void;
}

const SPEED_OPTIONS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

export const PlaybackSpeedSelector = memo(({
  currentSpeed,
  showSpeedMenu,
  onSpeedChange,
  onToggleMenu,
}: PlaybackSpeedSelectorProps) => {
  const formatSpeed = (speed: number): string => {
    if (speed === 1) return "Normal";
    return `${speed}x`;
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={onToggleMenu}
        className="text-white hover:text-gray-300 transition-colors text-sm font-medium px-2 py-1 rounded hover:bg-[#ffffff1a]"
      >
        {formatSpeed(currentSpeed)}
      </button>

      {showSpeedMenu && (
        <div className="absolute bottom-full right-0 mb-2 bg-[#000000e6] backdrop-blur-sm rounded-lg shadow-lg border border-[#ffffff33] min-w-[120px] z-20">
          <div className="py-2">
            {SPEED_OPTIONS.map((speed) => (
              <button
                type="button"
                key={speed}
                onClick={() => {
                  onSpeedChange(speed);
                  onToggleMenu();
                }}
                className={clsx(
                  "w-full text-left px-4 py-2 text-sm transition-colors",
                  "hover:bg-[#ffffff1a]",
                  currentSpeed === speed
                    ? "text-white bg-[#ffffff33]"
                    : "text-[#ffffffcc]"
                )}
              >
                {formatSpeed(speed)}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
});

PlaybackSpeedSelector.displayName = "PlaybackSpeedSelector";
